<template>
  <div id="content-wrap" style="text-align: center; padding: 10px;">
    <h1>Greetings!!</h1>
    <h3>Thank you for choosing <b>Printer Counters</b></h3>
    <br />
    <div v-if="showEmailBox" style="width: 320px; background-color: rgba(54, 127, 169, 0.2); margin: 0px auto; text-align: left; font-size: 18px;">
      <h4>Now you will get an email includes:</h4>
      <ol>
        <li>Verify your account</li>
        <li>Two links of downloads</li>
        <li>Authentication key for printers sites</li>
        <li>Your dashboard will be filled after the downloads in yours customers site</li>
      </ol>
    </div>
    <br />
    <h3>To login click here: <b style="color:#367fa9;"><a href="#" @click="$root.goto('Login')">Login</a></b></h3>
    <br />
    <h4>Please don't hesitate to <a href="#" @click="$root.goto('Contact')">contact us</a> for any further information.</h4>
    <br />
    <h4>Or ready the following installation guide:  <a href="#" @click="$root.goto('Guide')">Printer Counters Installation Guide.pdf</a></h4>
  </div>
</template>
<script>
  export default {
    name: 'thanks',
    data () {
      return {
      }
    },
    created () {
    },
    computed: {
      showEmailBox () {
        return (this.$route.name === 'Thanks')
      }
    },
    methods: {
    }
  }

</script>
<style>
  #service {
    background-color: #ecf0f5;
  }
</style>



// WEBPACK FOOTER //
// Thanks.vue?2228ac17